<template>
    <div>
        <b-container fluid class="mt-2 px-3 pb-2">
            <b-row>
                <b-col cols="" class="">
                    <b-row>
                        <b-col cols="">
                            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-0">
                                <h2 class="text-left mb-3">{{ title }}</h2>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="10" sm="12">
                            <div class="data-table team-data-table table-custom-border bg-white">
                                <div class="bg-white rounded">
                                    <div class="d-block text-center mt-4">
                                        <b-row class="align-items-center px-4 mb-0">
                                            <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('addUpdateVaultDoc.basic') }}</h3>

                                            <b-col md="6" sm="12" class="mt-3">
                                                <div class="text-left mb-2">
                                                    <label class="state">{{ $t('addUpdateVaultDoc.docTypeLabel') }}</label>
                                                    <v-select class="f-14" :options="docTypeOptions"
                                                        :reduce="(option) => option.id" @search="searchDocType"
                                                        v-model="payload.doc_type">
                                                        <span slot="no-options">
                                                            {{ $t('addUpdateVaultDoc.searchName') }}
                                                        </span>
                                                    </v-select>
                                                    <p v-if="errors && errors.doc_type" class="field-error pb-4">
                                                        {{ errors.doc_type[0] }}
                                                    </p>
                                                </div>
                                            </b-col>
                                            <b-col md="6" sm="12" class="mt-3">
                                                <div class="text-left ">
                                                    <b-form-group :label="$t('addUpdateVaultDoc.creatorLabel')" class="text-left mb-0">
                                                        <b-form-input type="text" class="unit f-14" v-model="creatorData"
                                                            disabled />
                                                    </b-form-group>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="align-items-center px-4 mb-3">
                                            <b-col md="6" sm="12" class="mt-3">
                                                <div class="text-left mb-2">
                                                    <label for="modal-smart-drop-plus-datepicker"
                                                        class="state">{{ $t('addUpdateVaultDoc.dateLabel') }}</label>
                                                    <date-picker :formatter="momentFormat" :range-separator="' - '"
                                                        :placeholder="$t('addUpdateVaultDoc.selectDate')" v-model="payload.date"
                                                        @clear="payload.date = ''" class="date-picker-custom f-14"
                                                        :teleport="'body'"></date-picker>
                                                    <p v-if="errors && errors.date" class="field-error pb-4">
                                                        {{ errors.date[0] }}
                                                    </p>
                                                </div>
                                            </b-col>
                                            <b-col md="6" sm="12" class="mt-3">
                                                <div class="text-left mb-2">
                                                    <label for="modal-smart-drop-plus-datepicker" class="state">{{ $t('addUpdateVaultDoc.expiryDateLabel') }}</label>
                                                    <date-picker :formatter="momentFormat" :range-separator="' - '"
                                                        :placeholder="$t('addUpdateVaultDoc.selectExpiryDate')" v-model="payload.expiry_date"
                                                        @clear="payload.expiry_date = ''" class="date-picker-custom f-14"
                                                        :teleport="'body'"></date-picker>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="align-items-center px-4 mb-3 mt-5 d-block">
                                            <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('addUpdateVaultDoc.assets') }}</h3>
                                            <b-row class="align-items-center px-3 mb-0">
                                                <b-col md="6" sm="12" class="mt-3">
                                                    <div class="text-left mb-2">
                                                        <label class="state">{{ $t('addUpdateVaultDoc.driverLabel') }}</label>
                                                        <v-select class="f-14" :options="driverOptions"
                                                            :reduce="(option) => option.id" @search="searchDriver"
                                                            v-model="payload.driver">
                                                            <span slot="no-options">
                                                                {{ $t('addUpdateVaultDoc.searchName') }}
                                                            </span>
                                                        </v-select>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row class="align-items-center px-3 mb-0">
                                                <b-col md="6" sm="12" class="mt-3">
                                                    <div class="text-left mb-2">
                                                        <label class="state">{{ $t('addUpdateVaultDoc.vehicleLabel') }}</label>
                                                        <v-select class="f-14" :options="vehicleOptions"
                                                            :reduce="(option) => option.id" @search="searchVehicle"
                                                            v-model="payload.vehicle">
                                                            <span slot="no-options">
                                                                {{ $t('addUpdateVaultDoc.searchVehicle') }}
                                                            </span>
                                                        </v-select>
                                                    </div>
                                                </b-col>
                                                <b-col md="6" sm="12" class="mt-3">
                                                    <div class="text-left mb-2">
                                                        <label class="state">{{ $t('addUpdateVaultDoc.trailerLabel') }}</label>
                                                        <v-select class="f-14" :options="trailerOptions"
                                                            :reduce="(option) => option.id" @search="searchTrailer"
                                                            v-model="payload.trailer">
                                                            <span slot="no-options">
                                                                {{ $t('addUpdateVaultDoc.searchTrailer') }}
                                                            </span>
                                                        </v-select>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-row>
                                        <b-row class="align-items-center px-4 mb-3 mt-5 d-block">
                                            <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('addUpdateVaultDoc.description') }}</h3>
                                            <b-row class="align-items-center px-3 mb-0">
                                                <b-col sm="12" class="mt-3">
                                                    <div class="text-left mb-2">
                                                        <label class="state">{{ $t('addUpdateVaultDoc.descriptionLabel') }}</label>
                                                        <b-form-textarea :placeholder="$t('addUpdateVaultDoc.descriptionPlaceholder')" rows="5"
                                                            class="f-14" v-model="payload.description"></b-form-textarea>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-row>
                                        <b-row class="align-items-center px-4 mb-3 mt-5 d-block">
                                            <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('addUpdateVaultDoc.documents') }}</h3>
                                            <b-row class="align-items-center px-3 mb-0">
                                                <b-col sm="12">
                                                    <div class="upload-btn-wrapper h-240px mt-3">
                                                        <b-img :src="require('@/assets/drop.svg')"></b-img>
                                                        <button class="foo">
                                                            {{ $t('addUpdateVaultDoc.dropDocument') }}
                                                        </button>
                                                        <p v-if="errors && errors.uploaded_files" class="field-error pb-4">
                                                            {{ errors.uploaded_files[0] }}
                                                        </p>
                                                        <input ref="docFile" type="file" name="docFile" class="right-0"
                                                            v-on:change="handleFileUpload" multiple
                                                            accept=".pdf, .png, .jpg, .jpeg, .doc, .docx, .mp4, .mov, .avi, .mkv, .ogg, .webm, .wmv, .svg, .ico, .tiff, .webp, .gif, .odp, .ods, .ppt, .xls, .pptx, .xlsx, .odt, .rtf, .mp3, .wav, .m4a, .wma, .ogg" />
                                                    </div>
                                                    <!-- File Thumbnails -->
                                                    <div v-if="payload.uploaded_files.length > 0"
                                                        class="d-flex flex-wrap gap-3 mt-3">
                                                        <div v-for="(file, index) in payload.uploaded_files" :key="index"
                                                            class="file-thumbnail-wrapper position-relative">
                                                            <!-- Image Preview -->
                                                            <img v-if="isImage(file)" :src="getFilePreview(file)"
                                                                class="file-thumbnail cursor-pointer"
                                                                @click="openPreview(file)" />
                                                            <!-- PDF Icon -->
                                                            <div v-else-if="isPDF(file)"
                                                                class="file-thumbnail file-icon-wrapper cursor-pointer"
                                                                @click="openPreview(file)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="40"
                                                                    height="40" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#E53935" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round">
                                                                    <path
                                                                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                                                                    </path>
                                                                    <polyline points="14 2 14 8 20 8"></polyline>
                                                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                                                    <polyline points="10 9 9 9 8 9"></polyline>
                                                                </svg>
                                                                <span class="file-type-label">PDF</span>
                                                            </div>
                                                            <!-- Doc Icon -->
                                                            <div v-else-if="isDoc(file)"
                                                                class="file-thumbnail file-icon-wrapper cursor-pointer"
                                                                @click="openPreview(file)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="40"
                                                                    height="40" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#1976D2" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round">
                                                                    <path
                                                                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                                                                    </path>
                                                                    <polyline points="14 2 14 8 20 8"></polyline>
                                                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                                                    <polyline points="10 9 9 9 8 9"></polyline>
                                                                </svg>
                                                                <span class="file-type-label">DOC</span>
                                                            </div>
                                                            <!-- Video Icon -->
                                                            <div v-else-if="isVideo(file)"
                                                                class="file-thumbnail file-icon-wrapper cursor-pointer"
                                                                @click="openPreview(file)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="40"
                                                                    height="40" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#7B1FA2" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round">
                                                                    <polygon points="23 7 16 12 23 17 23 7"></polygon>
                                                                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2">
                                                                    </rect>
                                                                </svg>
                                                                <span class="file-type-label">VIDEO</span>
                                                            </div>
                                                            <!-- Audio Icon -->
                                                            <div v-else-if="isAudio(file)"
                                                                class="file-thumbnail file-icon-wrapper cursor-pointer"
                                                                @click="openPreview(file)">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="40"
                                                                    height="40" viewBox="0 0 24 24" fill="none"
                                                                    stroke="#FF9800" stroke-width="2" stroke-linecap="round"
                                                                    stroke-linejoin="round">
                                                                    <path d="M9 18V5l12-2v13"></path>
                                                                    <circle cx="6" cy="18" r="3"></circle>
                                                                    <circle cx="18" cy="16" r="3"></circle>
                                                                </svg>
                                                                <span class="file-type-label">AUDIO</span>
                                                            </div>
                                                            <!-- Delete Button -->
                                                            <svg class="delete-file-btn" @click="removeFile(index)"
                                                                width="24" height="24" viewBox="0 0 30 30" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <rect width="30" height="30" rx="8" fill="#F5F5F5" />
                                                                <path
                                                                    d="M15.2873 7C15.9325 6.99991 16.5544 7.241 17.0309 7.67594C17.5074 8.11088 17.8041 8.70825 17.8628 9.35075H21.8694C22.0481 9.3508 22.2201 9.41868 22.3506 9.54066C22.4812 9.66264 22.5606 9.82964 22.5728 10.0079C22.5849 10.1862 22.529 10.3624 22.4163 10.501C22.3035 10.6396 22.1423 10.7303 21.9653 10.7546L21.8694 10.7612H21.3212L20.1299 21.0857C20.0768 21.544 19.8571 21.9668 19.5126 22.2737C19.1681 22.5805 18.7228 22.7501 18.2615 22.75H12.3131C11.8518 22.7501 11.4065 22.5805 11.062 22.2737C10.7175 21.9668 10.4978 21.544 10.4448 21.0857L9.25248 10.7612H8.70522C8.53481 10.7612 8.37016 10.6995 8.24172 10.5875C8.11329 10.4754 8.02976 10.3207 8.00658 10.1519L8 10.056C8.00001 9.88555 8.06172 9.7209 8.17374 9.59247C8.28575 9.46403 8.44048 9.38051 8.60931 9.35733L8.70522 9.35075H12.7118C12.7705 8.70825 13.0672 8.11088 13.5437 7.67594C14.0202 7.241 14.6421 6.99991 15.2873 7ZM13.8769 12.8769C13.6465 12.8769 13.4537 13.0226 13.4142 13.2144L13.4067 13.2887V19.048L13.4142 19.1214C13.4537 19.3132 13.6465 19.459 13.8769 19.459C14.1072 19.459 14.3 19.3132 14.3395 19.1214L14.347 19.0471V13.2897L14.3395 13.2144C14.3 13.0236 14.1072 12.8769 13.8769 12.8769ZM16.6978 12.8769C16.4674 12.8769 16.2746 13.0226 16.2351 13.2144L16.2276 13.2887V19.048L16.2351 19.1214C16.2746 19.3132 16.4674 19.459 16.6978 19.459C16.9281 19.459 17.1209 19.3132 17.1604 19.1214L17.1679 19.0471V13.2897L17.1604 13.2144C17.1209 13.0236 16.9281 12.8778 16.6978 12.8778V12.8769ZM15.2873 8.41045C14.7184 8.41045 14.2436 8.81478 14.1354 9.35075H16.4392C16.3301 8.81478 15.8562 8.41045 15.2873 8.41045Z"
                                                                    fill="#FF0000" />
                                                            </svg>
                                                            <!-- File Name -->
                                                            <p class="file-name text-truncate mb-0">{{ getFileName(file) }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-col sm="12" class="mt-5">
                                                <div class="d-flex justify-content-end">
                                                    <div class="text-right modal-footer border-0 p-0">
                                                        <b-button class="mx-0 h-40px w-100px" :class="hasChanged ? 'mr-3':''"
                                                            @click="$router.push('/dpb-vault')" variant="secondary">{{ $route.params.id ? $t('addUpdateVaultDoc.close') : $t('addUpdateVaultDoc.cancel') }}</b-button>
                                                        <b-button v-if="hasChanged" class="mx-0 h-40px w-100px" @click="sendDocumentData"
                                                            variant="primary">
                                                            {{ $t('addUpdateVaultDoc.save') }}
                                                        </b-button>
                                                    </div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <!-- File Preview Modal -->
        <b-modal v-model="showPreviewModal" size="lg" centered @hidden="panzoom = null" no-close-on-backdrop no-close-on-esc
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ previewFile ? getFileName(previewFile) : $t('addUpdateVaultDoc.previewTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="preview-content">
                <!-- Image Preview with Panzoom -->
                <div v-if="previewFile && isImage(previewFile)" class="image-preview-wrapper">
                    <div id="panzoom-element" ref="panzoomElement">
                        <img :src="getFilePreview(previewFile)" class="preview-image" />
                    </div>
                    <div class="zoom-section">
                        <b-icon @click="zoom(1)" icon="zoom-in" class="zoom-icon"></b-icon>
                        <b-icon @click="zoom(-1)" icon="zoom-out" class="zoom-icon"></b-icon>
                    </div>
                </div>
                <!-- PDF Preview -->
                <iframe v-else-if="previewFile && isPDF(previewFile)" :src="getFilePreview(previewFile)"
                    class="preview-pdf"></iframe>
                <!-- Video Preview -->
                <video v-else-if="previewFile && isVideo(previewFile)" :src="getFilePreview(previewFile)" controls
                    class="preview-video"></video>
                <!-- Audio Preview -->
                <div v-else-if="previewFile && isAudio(previewFile)" class="preview-audio-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none"
                        stroke="#FF9800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 18V5l12-2v13"></path>
                        <circle cx="6" cy="18" r="3"></circle>
                        <circle cx="18" cy="16" r="3"></circle>
                    </svg>
                    <audio :src="getFilePreview(previewFile)" controls class="preview-audio mt-4"></audio>
                </div>
                <!-- Doc Preview (Cannot preview inline) -->
                <div v-else-if="previewFile && isDoc(previewFile)" class="preview-doc">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none"
                        stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                    <p class="mt-3 mb-2">{{ $t('addUpdateVaultDoc.cannotPreview') }}</p>
                    <b-button variant="primary" @click="downloadFile(previewFile)">{{ $t('addUpdateVaultDoc.downloadFile') }}</b-button>
                </div>
            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mt-4">
                    <b-button class="mx-0 h-40px w-100px m-0" @click="showPreviewModal = false; panzoom = null;"
                        variant="secondary">{{ $t('addUpdateVaultDoc.close') }}</b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex"
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { checkDescriptionLength, checkValueExists, pickerDate } from "@/services/helper";
import Panzoom from '@panzoom/panzoom'
export default {
    name: "AddDPBVaultDoc",
    components: {
        DatePicker,
        vSelect
    },
    data() {
        return {
            checkDescriptionLength,
            checkValueExists,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            docTypeOptions: [],
            errors: {},
            showPreviewModal: false,
            previewFile: null,
            panzoom: null,
            defaultData: {
                doc_type: null,
                date: '',
                expiry_date: null,
                driver: null,
                vehicle: null,
                trailer: null,
                description: "",
                uploaded_files: []
            },
            payload: {
                doc_type: null,
                date: new Date(),
                expiry_date: null,
                driver: null,
                vehicle: null,
                trailer: null,
                description: "",
                uploaded_files: []
            },
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
        }
    },
    computed: {
        ...mapGetters(['user']),
        creatorData() {
            return this.$route.params.id ? this.payload.created_by : this.user?.first_name + " " + this.user?.last_name || ""
        },
        title() {
            return this.$route.params.id ? this.$t('addUpdateVaultDoc.updateTitle') : this.$t('addUpdateVaultDoc.addTitle')
        },
        hasChanged() {
            const currentDate = this.payload.date ? moment(this.payload.date).format('YYYY-MM-DD') : '';
            const defaultDate = this.defaultData.date ? moment(this.defaultData.date).format('YYYY-MM-DD') : '';
            const currentExpiryDate = this.payload.expiry_date ? moment(this.payload.expiry_date).format('YYYY-MM-DD') : '';
            const defaultExpiryDate = this.defaultData.expiry_date ? moment(this.defaultData.expiry_date).format('YYYY-MM-DD') : '';
            return currentDate !== defaultDate ||
                currentExpiryDate !== defaultExpiryDate ||
                this.defaultData.uploaded_files.length !== this.payload.uploaded_files.length ||
                Object.keys(this.payload).filter(field => {
                    if (field !== 'uploaded_files' && field !== 'date' && field !== 'expiry_date' && field !== 'created_by') {
                        if (!this.payload[field] && !this.defaultData[field]) return false
                        return this.checkValueExists(this.payload[field]) != this.checkValueExists(this.defaultData[field])
                    } return false
                }).length > 0
        }
    },
    methods: {
        ...mapActions(['getFilteredDrivers', 'getFilteredEquipments', 'setLoader', 'setNotification', 'getDPBVaultDocTypeData', 'addDPBVaultRecord', 'getDPBVaultDataById', 'deleteVaultDocument', 'updateVaultRecord']),
        handleFileUpload() {
            this.payload.uploaded_files = [...this.payload.uploaded_files, ...this.$refs.docFile.files]
            this.$refs.docFile.value = ''
        },
        getFileExtension(file) {
            // For local File objects
            if (file instanceof File) {
                return file.name.split('.').pop().toLowerCase()
            }
            // For backend URL objects
            if (file.file) {
                const url = file.file.split('?')[0] // Remove query params
                return url.split('.').pop().toLowerCase()
            }
            return ''
        },
        isImage(file) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico']
            if (file instanceof File) {
                const ext = file.name.split('.').pop().toLowerCase()
                return imageExtensions.includes(ext)
            }
            const ext = this.getFileExtension(file)
            return imageExtensions.includes(ext)
        },
        isPDF(file) {
            if (file instanceof File) {
                return file.type === 'application/pdf'
            }
            return this.getFileExtension(file) === 'pdf'
        },
        isDoc(file) {
            const docExtensions = ['doc', 'docx', 'odp', 'ods', 'ppt', 'xls', 'pptx', 'xlsx', 'odt', 'rtf', 'tiff']
            if (file instanceof File) {
                const ext = file.name.split('.').pop().toLowerCase()
                return docExtensions.includes(ext)
            }
            const ext = this.getFileExtension(file)
            return docExtensions.includes(ext)
        },
        isVideo(file) {
            const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'wmv']
            if (file instanceof File) {
                const ext = file.name.split('.').pop().toLowerCase()
                return videoExtensions.includes(ext)
            }
            const ext = this.getFileExtension(file)
            return videoExtensions.includes(ext)
        },
        isAudio(file) {
            const audioExtensions = ['mp3', 'wav', 'm4a', 'wma', 'ogg']
            if (file instanceof File) {
                const ext = file.name.split('.').pop().toLowerCase()
                return audioExtensions.includes(ext)
            }
            const ext = this.getFileExtension(file)
            return audioExtensions.includes(ext)
        },
        getFilePreview(file) {
            // For local File objects
            if (file instanceof File) {
                return URL.createObjectURL(file)
            }
            // For backend URL objects
            return file.file
        },
        getFileName(file) {
            // For local File objects
            if (file instanceof File) {
                return file.name
            }
            // For backend URL objects - extract filename from URL
            if (file.file) {
                const url = file.file.split('?')[0] // Remove query params
                const parts = url.split('/')
                return parts[parts.length - 1]
            }
            return 'Document'
        },
        async removeFile(index) {
            const file = this.payload.uploaded_files[index]
            try {
                if (!(file instanceof File) && file.id) {
                    this.setLoader(true);
                    await this.deleteVaultDocument(`${this.$route.params.id}/documents/${file.id}/`)
                    await this.setNotification({
                        msg: this.$t('addUpdateVaultDoc.documentDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false);
                }
                this.payload.uploaded_files = this.payload.uploaded_files.filter((_, i) => i !== index)
            }
            catch (e) {
                this.setLoader(false);
            }
        },
        openPreview(file) {
            this.previewFile = file
            this.showPreviewModal = true
            this.panzoom = null
        },
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        downloadFile(file) {
            let url, filename
            if (file instanceof File) {
                url = URL.createObjectURL(file)
                filename = file.name
            } else {
                url = file.file
                filename = this.getFileName(file)
            }
            const link = document.createElement('a')
            link.href = url
            link.download = filename
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            if (file instanceof File) {
                URL.revokeObjectURL(url)
            }
        },
        async searchDriver(searchText) {
            if (searchText && searchText.length >= 2) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (key === 'uploaded_files' && Array.isArray(value) && value.length === 0) {
                    nullKeys.push(key);
                }
                else {
                    if (!value) {
                        nullKeys.push(key);
                    }
                }
            }
            return nullKeys;
        },
        async searchDocType(searchText) {
            if (searchText) {
                let options = [];
                const { data } = await this.getDPBVaultDocTypeData({ url: `search=${searchText}&search_list=type` });
                data.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.type,
                    });
                });
                this.docTypeOptions = this.docTypeOptions.concat(options)
                this.docTypeOptions = [...new Map(this.docTypeOptions.map(item => [item['id'], item])).values()]
            }
        },

        async searchVehicle(searchText) {
            if (searchText) {
                let options = [];
                const vehicleRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle" });
                vehicleRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.vehicleOptions = this.vehicleOptions.concat(options)
                this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                let options = [];
                const trailerRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer" });
                trailerRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.trailerOptions = this.trailerOptions.concat(options)
                this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
            }
        },
        async sendDocumentData() {
            try {
                if (this.payload.description && this.checkDescriptionLength(this.payload.description)) {
                    throw {
                        description: [this.$t('addUpdateVaultDoc.descriptionMaxLength')],
                    };
                }
                const nullKeys = this.checkNullValues({
                    date: this.payload.date,
                    uploaded_files: this.payload.uploaded_files,
                    doc_type: this.payload.doc_type
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    const formData = new FormData();
                    formData.append("doc_type", this.payload.doc_type);
                    formData.append("date", moment(this.payload.date).format("YYYY-MM-DD"));
                    if (this.payload.expiry_date) {
                        formData.append("expiry_date", moment(this.payload.expiry_date).format("YYYY-MM-DD"));
                    }
                    if (this.payload.driver) {
                        formData.append("driver", this.payload.driver);
                    }
                    if (this.payload.vehicle) {
                        formData.append("vehicle", this.payload.vehicle);
                    }
                    if (this.payload.trailer) {
                        formData.append("trailer", this.payload.trailer);
                    }
                    formData.append("description", this.payload.description);
                    this.payload.uploaded_files.forEach((file) => {
                        if (file instanceof File) {
                            formData.append("uploaded_files", file);
                        }
                    });
                    if (this.$route.params.id) {
                        await this.updateVaultRecord({ id: this.$route.params.id, payload: formData });
                        await this.setNotification({
                            msg: this.$t('addUpdateVaultDoc.documentUpdated'),
                            type: "success",
                            color: "green",
                        });
                    }
                    else {
                        await this.addDPBVaultRecord(formData);
                        await this.setNotification({
                            msg: this.$t('addUpdateVaultDoc.documentCreated'),
                            type: "success",
                            color: "green",
                        });
                    }
                    this.setLoader(false);
                    this.$router.push('/dpb-vault')
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('addUpdateVaultDoc.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    },
    async mounted() {
        try {
            this.setLoader(true);
            if (this.$route.params.id) {
                const data = await this.getDPBVaultDataById(this.$route.params.id);
                this.docTypeOptions = [{
                    id: data.doc_type.id,
                    label: data.doc_type.type,
                }]
                if (data.driver) {
                    this.driverOptions = [{
                        id: data.driver.id,
                        label: data.driver.name,
                    }]
                }
                if (data.vehicle) {
                    this.vehicleOptions = [{
                        id: data.vehicle.id,
                        label: data.vehicle.unit_no,
                    }]
                }
                if (data.trailer) {
                    this.trailerOptions = [{
                        id: data.trailer.id,
                        label: data.trailer.unit_no,
                    }]
                }
                this.payload = {
                    doc_type: data.doc_type.id,
                    date: pickerDate(data.date),
                    expiry_date: data.expiry_date ? pickerDate(data.expiry_date) : null,
                    driver: data.driver ? data.driver.id : null,
                    vehicle: data.vehicle ? data.vehicle.id : null,
                    trailer: data.trailer ? data.trailer.id : null,
                    description: data.description,
                    uploaded_files: data.documents,
                    created_by: data.created_by.name
                }
                this.defaultData = {
                    doc_type: this.payload.doc_type,
                    date: this.payload.date ? moment(this.payload.date).format('YYYY-MM-DD') : '',
                    expiry_date: this.payload.expiry_date ? moment(this.payload.expiry_date).format('YYYY-MM-DD') : '',
                    driver: this.payload.driver,
                    vehicle: this.payload.vehicle,
                    trailer: this.payload.trailer,
                    description: this.payload.description,
                    uploaded_files: [...this.payload.uploaded_files]
                }
            }
            this.setLoader(false);
        }
        catch (error) {
            console.log(error)
            this.setLoader(false);
        }
    }
}   
</script>
<style scoped>
.file-thumbnail-wrapper {
    width: 120px;
    text-align: center;
}

.file-thumbnail {
    width: 120px;
    height: 120px;
    border: 1px solid #EEEEEE;
    border-radius: 8px;
    object-fit: cover;
}

.file-icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #F5F5F5;
}

.file-type-label {
    font-size: 12px;
    font-weight: 600;
    margin-top: 4px;
    color: #666;
}

.delete-file-btn {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    z-index: 1;
}

.file-name {
    font-size: 12px;
    color: #333;
    max-width: 120px;
    margin-top: 4px;
}

.gap-3 {
    gap: 1rem;
}

.cursor-pointer {
    cursor: pointer;
}

.preview-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.preview-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
}

.preview-pdf {
    width: 100%;
    height: 70vh;
    border: none;
}

.preview-video {
    max-width: 100%;
    max-height: 70vh;
}

.preview-doc {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
    color: #666;
}

.image-preview-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
}

#panzoom-element {
    overflow: hidden;
    max-height: 60vh;
    width: 100%;
    display: flex;
    justify-content: center;
}

.zoom-section {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 0;
    background-color: #323639;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.zoom-icon {
    fill: white;
    cursor: pointer;
    width: 16px;
    height: 16px;
}

.preview-audio-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    width: 100%;
}

.preview-audio {
    width: 100%;
    max-width: 500px;
    height: 54px;
    border-radius: 30px;
    background-color: #f1f3f4;
}

.preview-audio::-webkit-media-controls-panel {
    background-color: #f1f3f4;
}

.preview-audio::-webkit-media-controls-play-button {
    background-color: #FF9800;
    border-radius: 50%;
    transform: scale(1.3);
}

.preview-audio::-webkit-media-controls-current-time-display,
.preview-audio::-webkit-media-controls-time-remaining-display {
    font-size: 14px;
    font-weight: 500;
}
</style>
